import { FeatureNameEnum } from './../shared/feature/feature-name.enum';
import { FeatureService } from './../shared/feature/feature.service';
import { UserRead } from './../users/shared/user-read.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PagedResultGeneric } from './../shared/model/paged-result.model';
import { SalesOpportunityService } from './../sales-opportunities/shared/sales-opportunity.service';
import { UserService } from '../users/shared/user.service';
import { SalesOpportunitySearchDto } from '../sales-opportunities/shared/dto/sales-opportunity-search.dto';
import { SalesOpportunityDto } from '../sales-opportunities/shared/dto/sales-opportunity.dto';
import { TaskService } from '../tasks/shared/task.service';
import { TaskSearchDto } from '../tasks/shared/dto/task-search.dto';
import { AuthService, NotificationService, TranslationService } from '../shared';
import { ConfigServiceService } from '../config/shared/config-service.service';
import { DashboardConfigDto } from '../config/shared/dto/dashboard-config.dto';
import { HttpErrorResponse } from '@angular/common/http';
import { DashboardNeoMembershipActivityComponent } from './dashboard-neo-membership-activity/dashboard-neo-membership-activity.component';

@Component({
  selector: 'wl-dashboard-neo',
  templateUrl: 'dashboard-neo.component.html',
  styleUrls: ['dashboard-neo.component.less'],
  standalone: false
})
export class DashboardNeoComponent implements OnInit {
  private _userService: UserService;

  public hideEvents: boolean;
  public hideRevenueReports: boolean;
  public hideRevenueModule = true;
  public hideRetention = true;
  public hideMyReports = true;
  public hideSalesOpps = true;
  public hideTasks = true;
  public hideMembership = true;

  @ViewChild(DashboardNeoMembershipActivityComponent) membershipComponent: DashboardNeoMembershipActivityComponent;

  public config: DashboardConfigDto = {} as DashboardConfigDto;
  public showConfig = false;
  public isSaving = false;

  public showTenantSelection = false;

  public constructor(
    userService: UserService,
    private _configService: ConfigServiceService,
    private _salesOppService: SalesOpportunityService,
    private _taskService: TaskService,
    private _featureService: FeatureService,
    private _notificationService: NotificationService,
    private _translationService: TranslationService,
    private _authService: AuthService
  ) {
    this._userService = userService;
    this.hideEvents = true;
    this.hideRevenueReports = true;
  }

  ngOnInit() {
    if (this._authService.getTenant() == 'Personify') {
      this.hideEvents = true;
      this.hideRevenueReports = true;
      this.hideSalesOpps = true;
      this.hideTasks = true;
      this.showTenantSelection = true;
    } else {
      this._userService.getCurrentUserSecurityElementAccessLevel('Reports Module').then((reportsAccess: number) => {
        if (reportsAccess > 0) {
          this.hideMyReports = false;
          this._userService.getCurrentUserSecurityElementAccessLevel('Dashboard Retention').then((data: number) => {
            if (data > 0) {
              this.hideRetention = false;
            }
          });
          this._userService.getCurrentUserSecurityElementAccessLevel('Dashboard Membership').then((data: number) => {
            if (data > 0) {
              this.hideMembership = false;
            }
          });

          this._userService.getCurrentUserSecurityElementAccessLevel('Dashboard Financial').then((data: number) => {
            if (data > 0) {
              this.hideRevenueModule = false;
            }
          });
        }
      });

      this._userService.getCurrentUserSecurityElementAccessLevel('Event Reports').then((data: number) => {
        if (data > 0) {
          this.hideEvents = false;
        }
      });

      this._userService.getCurrentUserSecurityElementAccessLevel('Revenue Reports').then((data: number) => {
        if (data > 0) {
          this.hideRevenueReports = false;
        }
      });

      this._featureService.has(FeatureNameEnum.SalesOpportunities).then((featureLicense) => {
        if (featureLicense) {
          this._userService.getCurrentUser().then((data: UserRead) => {
            const search = { AssignedTo: data.UserNum, PageSize: 1 } as SalesOpportunitySearchDto;
            this._salesOppService.search(search).then((result: PagedResultGeneric<SalesOpportunityDto>) => {
              this.hideSalesOpps = result.TotalCount <= 0;
            });
          });
        }
      });

      const search: TaskSearchDto = {
        PageSize: 10,
        PageNumber: 1,
        OrderBy: 'DateDue',
        TotalPages: 1,
        TotalCount: 0,
      } as TaskSearchDto;
      this._taskService.getMyTasks(search, true).then((data) => {
        this.hideTasks = data.TotalCount <= 0;
      });

      this.loadSavedConfig();
    }
  }

  loadSavedConfig() {
    this._userService.getCurrentUser().then((user: UserRead) => {
      this._configService.getUserDashboardSettings(user.UserNum).then((config: DashboardConfigDto) => {
        if (config) {
          this.config = config;
        } else {
          this.config = {
            UserNum: user.UserNum,
            OverrideDateRange: false,
            ShowUpcomingEvents: true,
            ShowMembershipActitiyTotals: true,
            ShowFinance: true,
            ShowMyReports: true,
            ShowMySalesOpportunities: true,
            ShowMyTasks: true,
          } as DashboardConfigDto;
        }

        if (!this.config.OverrideDateRange) {
          this.config.StartDate = new Date(new Date().getFullYear(), 0, 1);
          this.config.EndDate = new Date();
        }
      });
    });
  }

  openConfig() {
    this.showConfig = true;
  }

  saveConfig() {
    this.isSaving = true;
    this._configService
      .upsertUserDashboardSettings(this.config)
      .then((data) => {
        if (data) {
          this._notificationService.translateSuccess('dashboard.config.config-saved-success');
          this.showConfig = false;
        }
      })
      .catch((err: HttpErrorResponse) => {
        this._notificationService.error(`${this._translationService.getInstant('dashboard.config.config-saved-error')}: ${err.message}`);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  cancelConfig() {
    this.showConfig = false;
    this.loadSavedConfig();
  }

  scrollToElement(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
